import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExportToDocumentService {
  constructor() {}

  exportToCsv(data: any[], filename: string, headers?: string[]): void {
    const csvData = this.createCsvData(data, headers);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  createCsvData(data: any[], headers?: string[]): string {
    let csv = '';

    if (headers) {
      csv += headers.join(',') + '\n';
    }

    data.forEach((row) => {
      const keys = Object.keys(row);
      let rowData = '';

      keys.forEach((key, index) => {
        const value = row[key];
        rowData += `"${value}"${index < keys.length - 1 ? ',' : ''}`;
      });

      csv += rowData + '\n';
    });

    return csv;
  }
}
